import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import step1 from "../Image/SS/sign-up.jpg";
import step2 from "../Image/SS/sign-in.jpg";
import step3 from "../Image/SS/profile-setup.jpg";
import step4 from "../Image/SS/update_profile.jpg";
import step5 from "../Image/SS/mala-gallary.jpg";
import step6 from "../Image/SS/invite-img.jpg";
import step7 from "../Image/SS/Rewards-Tasks.jpg";
import step8 from "../Image/SS/trackMalaCount.jpg";
import step9 from "../Image/SS/collect_fram.jpg";

const HowItWorks = () => {
  const { t } = useTranslation();
  const [rowInView, setRowInView] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const useObserveInView = (index) => {
    const rowRef = useRef(null);
    const [isInView, setIsInView] = useState(false);
    const [isScrollingDown, setIsScrollingDown] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
      const rowElement = rowRef.current;

      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        setIsScrollingDown(currentScrollY > lastScrollY);
        setLastScrollY(currentScrollY);
      };

      window.addEventListener("scroll", handleScroll);

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && isScrollingDown) {
            setIsInView(true);
          } else {
            setIsInView(false);
          }
        },
        { threshold: 0.5 }
      );

      if (rowElement) {
        observer.observe(rowElement);
      }

      return () => {
        window.removeEventListener("scroll", handleScroll);
        if (rowElement) {
          observer.unobserve(rowElement);
        }
      };
    }, [lastScrollY, isScrollingDown]);

    useEffect(() => {
      setRowInView((prev) => {
        const updated = [...prev];
        updated[index] = isInView;
        return updated;
      });
    }, [isInView, index]);

    return { rowRef, isInView };
  };

  return (
    <Container className="my-5" id="howItWorks">
      <h2
        className={`text-center mb-4 feature-title animate__animated ${
          rowInView[0] ? "animate__fadeIn" : ""
        }`}
      >
        {t("howItWorksPage.title")}
      </h2>

      <Row className="d-flex justify-content-center">
        {/* Step 1 */}
        <div ref={useObserveInView(0).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[0] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="order-2 order-md-1 How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[0] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step1.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[0] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step1.description")}
                  </p>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`order-1 order-md-2 text-center ${
                    rowInView[0] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step1}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 2 */}
        <div ref={useObserveInView(1).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[1] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`text-center ${
                    rowInView[1] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step2}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="align-self-center How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[1] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step2.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[1] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step2.description")}
                  </p>
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 3 */}
        <div ref={useObserveInView(2).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[2] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="order-2 order-md-1 How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[2] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step3.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[2] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step3.description")}
                  </p>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`order-1 order-md-2 text-center ${
                    rowInView[2] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step3}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 4 */}
        <div ref={useObserveInView(3).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[3] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`text-center ${
                    rowInView[3] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step4}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="align-self-center How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[3] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step4.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[3] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step4.description")}
                  </p>
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 5 */}
        <div ref={useObserveInView(4).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[4] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="order-2 order-md-1 How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[4] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step5.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[4] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step5.description")}
                  </p>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`order-1 order-md-2 text-center ${
                    rowInView[4] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step5}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 6 */}
        <div ref={useObserveInView(5).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[5] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`text-center ${
                    rowInView[5] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step6}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="align-self-center How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[5] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step6.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[5] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step6.description")}
                  </p>
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 7 */}
        <div ref={useObserveInView(6).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[6] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="order-2 order-md-1 How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[6] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step7.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[6] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step7.description")}
                  </p>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`order-1 order-md-2 text-center ${
                    rowInView[6] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step7}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 8 */}
        <div ref={useObserveInView(7).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[7] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`text-center ${
                    rowInView[7] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step8}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="align-self-center How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[7] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step8.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[7] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step8.description")}
                  </p>
                </Col>
              </div>
            </div>
          </section>
        </div>

        {/* Step 9 */}
        <div ref={useObserveInView(8).rowRef}>
          <section
            className={`py-3 py-md-4 py-sm-4 ${
              rowInView[8] ? "animate__animated animate__fadeIn" : ""
            }`}
          >
            <div className="container px-3 p-lg-0">
              <div className="row justify-content-between align-items-center">
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className="order-2 order-md-1 How_it_work_text_sec"
                >
                  <h4
                    className={`mb-20 howWorktxt1 text-dark fw-semibold ${
                      rowInView[8] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step9.title")}
                  </h4>
                  <p
                    className={`howWorktxt2 ${
                      rowInView[8] ? "animate__animated animate__fadeIn" : ""
                    }`}
                  >
                    {t("howItWorksPage.step9.description")}
                  </p>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  xs={12}
                  className={`order-1 order-md-2 text-center ${
                    rowInView[8] ? "animate__animated animate__zoomIn" : ""
                  }`}
                >
                  <img
                    src={step9}
                    className="how_work_img rounded-4 shadow mb-4 mb-md-0"
                    alt="steps"
                  />
                </Col>
              </div>
            </div>
          </section>
        </div>
      </Row>
    </Container>
  );
};

export default HowItWorks;
